/* jshint esnext: true */
import Form from './Form';

export default class extends Form {
    constructor (options) {
        super(options);

        this.setElements();

        this.$el.on('change.ContactForm', '.js-problem-input', (event) => {
            this.$el.find('.js-problem-details').slideDown();
            this.$el.find('.js-problem-collapser').addClass('is-open');
        });
    }

    destroy() {
        this.$el.off('.ContactForm');
    }
}
